import {Component, Input, OnChanges, inject} from '@angular/core';
import {DecimalPipe} from '@angular/common';
import {FilterService} from '../../../services/filter.service';

@Component({
  selector: 'app-avgdailymileage-display',
  templateUrl: './avgdailymileage-display.component.html',
  styleUrls: ['./avgdailymileage-display.component.scss'],
  standalone: true,
  imports: [DecimalPipe],
})
export class AvgDailyMileageDisplayComponent implements OnChanges {
  filterService = inject(FilterService);

  @Input() avgDailyMileage: number;
  @Input() avgDailyMileageArrow: string;
  showAvgDailyMileage: boolean = true;
  showAvgDailyMileageArrow: boolean = true;
  ngOnChanges(): void {
    if (!this.avgDailyMileage) this.showAvgDailyMileage = false;
  }
}
